import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-golden disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-burgundy text-white hover:bg-[#A52222] active:bg-burgundy glow-gold',
    secondary: 'bg-jet text-white hover:bg-jet/80 active:bg-burgundy active:text-white',
    outline: 'border-2 border-jet text-jet hover:bg-jet hover:text-white active:bg-burgundy active:border-burgundy active:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-semibold'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-363">
      {children}
    </motion.button>;
}